import { Navigate, useLocation } from 'react-router-dom';
import { useAuthentication } from '../hooks';
import { ADMINS } from '../environment';

function useAdmin() {
   const { user } = useAuthentication();
   return ADMINS.includes(user?.email);
}

const PrivateRoute = ({ children, admin = false }) => {
   const { accessToken } = useAuthentication();
   const isAdmin = useAdmin();
   const location = useLocation();

   if (!accessToken || (admin && !isAdmin)) {
      return <Navigate to="/" replace state={{ from: location }} />;
   }

   return children;
};

export default PrivateRoute;
